
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke-width":"1.5","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"clip-rule":"evenodd","d":"M8.998 15.001l3.151-.389a1 1 0 00.586-.285l7.634-7.63a2.166 2.166 0 000-3.061v0a2.166 2.166 0 00-3.063 0l-7.563 7.563a1 1 0 00-.283.566L8.998 15z"}}),_c('path',{attrs:{"d":"M11.5 3.997a8.504 8.504 0 108.503 8.503M18.531 8.529l-3.062-3.063"}})])
          )
        }
      }
    